export enum ASK_AI {
    /**
     * @value AI Answer.
     */
    AI_ANSWER = 'ASK_AI.AI_ANSWER',
    /**
     * @value Ask anything
     */
    ASK_ANYTHING = 'ASK_AI.ASK_ANYTHING',
    /**
     * @value Ask for more details.
     * @description Placeholder displayed in the Ask AI follow-up questions text input
     */
    ASK_FOR_MORE_DETAILS = 'ASK_AI.ASK_FOR_MORE_DETAILS',
    /**
     * @value Close follow-up questions
     * @description Label of the button closing the follow-up questions section of the Ask AI results
     */
    CLOSE_FOLLOW_UP_QUESTIONS = 'ASK_AI.CLOSE_FOLLOW_UP_QUESTIONS',
    /**
     * @value Collapse answer
     * @description Label displayed in the "show less" button of the Ask AI results
     */
    COLLAPSE_ANSWER = 'ASK_AI.COLLAPSE_ANSWER',
    /**
     * @value {"one":"%COUNT% follow-up question","other":"%COUNT% follow-up questions"}
     * @description Ask AI follow up questions counter, displayed when the section is closed.
     */
    COUNT_FOLLOW_UP_QUESTIONS = 'ASK_AI.COUNT_FOLLOW_UP_QUESTIONS',
    /**
     * @value Try again or come back later.
     * @description Description displayed when no results are found by AI
     */
    ERROR_DESC = 'ASK_LUMAPPS.ERROR_DESC',
    /**
     * @value Ask AI service is temporarily unavailable
     * @description Title when an error occured with Lumapps AI service
     */
    ERROR_TITLE = 'ASK_LUMAPPS.ERROR_TITLE',
    /**
     * @value Expand answer
     * @description Label displayed in the "show more" button of the Ask AI results
     */
    EXPAND_ANSWER = 'ASK_AI.EXPAND_ANSWER',
    /**
     * @value Hide related resources
     */
    HIDE_RELATED_RESOURCES = 'ASK_LUMAPPS.HIDE_RELATED_RESOURCES',
    /**
     * @value I can help with that. Try the application below:
     * @description Sentence displayed before a micro-app is inserted in an Ask AI answer
     */
    MICRO_APP_ANSWER_INTRODUCTION = 'ASK_AI.MICRO_APP_ANSWER_INTRODUCTION',
    /**
     * @value No resources found
     * @description Title when no results are returned by AI
     */
    NO_RESOURCES_TITLE = 'ASK_LUMAPPS.NO_RESOURCES_TITLE',
    /**
     * @value You have reached your maximum Ask AI usage.
     * @description Description displayed when a user has reached their Ask AI rate limit
     */
    REACHED_MAXIMUM_USAGE = 'ASK_AI.REACHED_MAXIMUM_USAGE',
    /**
     * @value This answer is verified.
     * @description Message displayed in search result when ask AI returns an answer based on a rule set by an administrator
     */
    RULE_BASED_RESULT = 'ASK_LUMAPPS.RULE_BASED_RESULT',
    /**
     * @value Show related resources
     */
    SHOW_RELATED_RESOURCES = 'ASK_LUMAPPS.SHOW_RELATED_RESOURCES',
    /**
     * @value Visible to Ask AI administrators only
     * @description Administrator visibility restriction information message for Ask AI
     */
    VISIBLE_TO_ADMINISTRATORS = 'ASK_LUMAPPS.VISIBLE_TO_ADMINISTRATORS',
}
